export function ADD_CLIENT(body = {}) {
    return {
        type: "ADD_CLIENT",
        body
    };
};

export function UPDATE_CLIENT(body = {}){
    return {
        type: "UPDATE_CLIENT",
        body
    }
}

export function REMOVE_CLIENT(body = {}){
    return {
        type: "REMOVE_CLIENT",
        body
    }
}

export function GET_CLIENTS(body = {}) {
    return {
        type: "GET_CLIENTS",
        body
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/client.js